'use client';
import { jsx } from 'react/jsx-runtime';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const StandardForm = renderWithRef('StandardForm', null, (r, n)=>{
    useDeprecatedProps('StandardForm', r, [
        {
            propName: 'variant',
            instructions: 'As this variant is rarely used, it has been deprecated to improve consistency for customers, better align with post-elev8 design standards, and reduce UX debt.'
        },
        {
            propName: 'skin',
            instructions: 'With the new visual language, this prop has become redundant.'
        }
    ]);
    let { children: i, variant: s = 'vertical', skin: c = 'standard' } = r, p = _object_without_properties(r, [
        "children",
        "variant",
        "skin"
    ]), a = [
        'swan-form'
    ];
    return 'horizontal' === s && a.push('swan-form-horizontal'), 'tight' === c && a.push('swan-form-skin-tight'), jsx(RenderComp, {
        root: "form",
        forwardedRef: n,
        props: _object_spread_props(_object_spread({}, p), {
            onSubmit: p.onSubmit || p.method || p.action ? p.onSubmit : (e)=>e.preventDefault()
        }),
        classNames: a,
        children: i
    });
});

export { StandardForm };
